import React from "react";

// Primereact
import { Dialog } from "primereact/dialog";

// Components
import { ImportModalFooter } from "./components/ImportModalFooter";
import { ImportModalContent } from "./components/ImportModalContent";

// Styles
import * as styles from "./ImportModal.module.css";

export const ImportModal = ({
  showImportModal,
  setShowImportModal,
  uploadRef,
  onFileUpload
}) => {

  return (
    <Dialog
      header="Choose File"
      visible={showImportModal}
      onHide={() => setShowImportModal(false)}
      modal
      className={styles.importModal}
      footer={() => (
        <ImportModalFooter
          uploadRef={uploadRef}
          setShowImportModal={setShowImportModal}
        />
      )}
    >
      <ImportModalContent uploadRef={uploadRef} onFileUpload={onFileUpload} />
    </Dialog>
  );
};
